import React, { Suspense, useState, useMemo } from 'react';
import { Col, Row, Skeleton } from 'antd';
import Section from 'components/Common/Section';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import ButtonVoltar from 'components/Common/ButtonVoltar';
import ButtonImage from 'components/Common/ButtonImage';
import PDFViewer from 'components/Common/PDFViewer';

import { consultarVeiculoV110Clear } from 'store/modules/api/detranCrv/SolicitarDocumentos/ConsultarVeiculoV110/actions';
import { emitirAlteracaoDadosCadastraisClear } from 'store/modules/api/detranCrv/SolicitarDocumentos/emitirAlteracaoDadosCadastrais/actions';

const AlteracaoDadosCadastraisImpressao: React.FC = () => {
	const dispatch = useDispatch();
	const { emitirAlteracaoDadosCadastrais, emitirModificacaoDadosCadastrais } =
		useSelector(
			(state: ApplicationState) => state.api.detranCrv.solicitarDocumentos,
		);

	const [showPrint, setShowPrint] = useState<boolean>(false);

	const title = useMemo(() => {
		return `Resultado do Pedido de ${
			emitirAlteracaoDadosCadastrais.status === 200
				? 'Alteração'
				: 'Modificação'
		} de Dados Cadastrais`;
	}, [emitirAlteracaoDadosCadastrais.status]);

	return (
		<Suspense fallback={<Skeleton paragraph={{ rows: 4 }} />}>
			<Section title={title}>
				<Row gutter={[0, 10]}>
					<Col span={2} />
					<Col span={4}>Número da Ficha:</Col>
					<Col span={18}>
						<strong>{emitirAlteracaoDadosCadastrais.data?.numeroficha}</strong>
						<strong>
							{emitirModificacaoDadosCadastrais.data?.numeroficha}
						</strong>
					</Col>
					<Col span={2} />
					<Col span={4}>Ano da Ficha:</Col>
					<Col span={18}>
						<strong>{emitirAlteracaoDadosCadastrais.data?.anoFicha}</strong>
						<strong>{emitirModificacaoDadosCadastrais.data?.anoFicha}</strong>
					</Col>
				</Row>
				<Row justify="end" align="top" gutter={[20, 10]}>
					<ButtonImage src="imprimir" onClick={() => setShowPrint(true)} />
				</Row>
			</Section>
			<ButtonVoltar
				route="/detran-crv/alteracao-dados-cadastrais/consultar"
				onClick={() => {
					dispatch(emitirAlteracaoDadosCadastraisClear());
					dispatch(consultarVeiculoV110Clear());
				}}
			/>
			{showPrint && emitirAlteracaoDadosCadastrais.data?.planilhaRenavam && (
				<PDFViewer
					title="Ficha Alteração de Dados Cadastrais"
					source={
						emitirAlteracaoDadosCadastrais.data?.planilhaRenavam
							? emitirAlteracaoDadosCadastrais.data?.planilhaRenavam
							: ''
					}
					onClose={() => setShowPrint(false)}
				/>
			)}
			{showPrint && emitirModificacaoDadosCadastrais.data?.planilhaRenavam && (
				<PDFViewer
					title="Ficha Modificação de Dados Cadastrais"
					source={
						emitirModificacaoDadosCadastrais.data?.planilhaRenavam
							? emitirModificacaoDadosCadastrais.data?.planilhaRenavam
							: ''
					}
					onClose={() => setShowPrint(false)}
				/>
			)}
		</Suspense>
	);
};

export default AlteracaoDadosCadastraisImpressao;
